export const EXTERNAL_USER_SEARCHES_FETCH_REQUEST = 'EXTERNAL_USER_SEARCHES_FETCH_REQUEST'
export const EXTERNAL_USER_SEARCHES_FETCH_SUCCESS = 'EXTERNAL_USER_SEARCHES_FETCH_SUCCESS'
export const EXTERNAL_USER_SEARCHES_FETCH_FAILURE = 'EXTERNAL_USER_SEARCHES_FETCH_FAILURE'
